module.exports = "/_next/static/images/0976e429cf1fb130a3340fa1ff8a5932-nucommunity-md@3x.jpg";